import React from "react";
import { useLocation } from "react-router-dom";
import "./MapLivePage.css";

export default function MapLivePage() {
  const location = useLocation();
  const frameSrc = `/legacy/mapLive/maplive.html${location.search}`;

  return (
    <main className="map-live-page">
      <iframe
        className="map-live-frame"
        src={frameSrc}
        title="MapLive"
        allow="geolocation; clipboard-write"
      />
    </main>
  );
}
